
import { getCookie } from './../dom/modules/cookies.js';

export default {
    'Content-Type': 'application/json',
    'X-CSRFToken':  getCookie("csrftoken")
};
